import React from 'react';
import PropTypes from 'prop-types';
import ChipInput from 'material-ui-chip-input';

class PairInput extends React.Component {
  addPartOfPair = (part) => {
    const { pair } = this.props;
    if (pair.length >= 2) {
      return;
    }
    const next = [...pair, part];
    this.props.onChange(next);
  }
  removePartOfPair = (part) => {
    const { pair } = this.props;
    const next = pair.filter((p) => p !== part);
    this.props.onChange(next);
  }
  render() {
    const {
      pair, label,
    } = this.props;
    return (
      <ChipInput
        value={pair}
        floatingLabelText={label}
        // Some how this component needs all three of the below to work
        onChange={this.props.onChange}
        onRequestAdd={this.addPartOfPair}
        onRequestDelete={this.removePartOfPair}
      />
    );
  }
}

PairInput.propTypes = {
  pair: PropTypes.arrayOf(PropTypes.string).isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default PairInput;
